import React, { useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { Grid, Modal, Button, Typography, Box, Chip, Divider } from "@mui/material";
import BmjLogo from "./assets/logo/bmjLogo.svg";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import "./style/sass/header.scss";
// import "./style/sass/heroSection.scss";
import bmjVideo from "./assets/video/bmj-video.mp4"

import CloseIcon from "@mui/icons-material/Close";
// import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { LaunchOutlined } from "@mui/icons-material";




function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

export default function App() {
  // const location = useLocation();
  


  // Access the pathname of the current route
  // const currentPath = location.pathname;

  // const isHomePage = currentPath === "/";

  return (
    <React.Fragment>
      {/* <Auth open={open} handleCloseModal={handleCloseModal} setOpen={setOpen} /> */}
      {/* <MobileSidebar open={openDrawer} onClose={handleCloseDrawer} /> */}

      
      <Grid container sx={{ backgroundColor: "#333333", minHeight: "100vh" }}>
        <Header />
        <Grid item xs={12} mt={{ xs: "0em", md: "3em" }} display={{ xs: "block", md: "flex" }} justifyContent={{ xs: "none", md: "center" }} alignItems={{ xs: "none", md: "center" }}>
          <Grid container>
            <Grid item xs={12} display={{ xs: "block", md: "block" }} marginTop={{ xs: "6em", md: "3em" }} sx={{ padding: "1em", textAlign: "center" }}>
              <Grid container>
                <Grid item xs={12} display="flex" justifyContent="center" alignItems="center" sx={{ color: "#fff", marginBottom: "1em" }}>
                  <Typography variant="h4" component="h3" >
                    We are launching soon </Typography>
                </Grid>
                <Grid item xs={12} sx={{color:"#fff"}}>
                <Typography variant="h6" component="h3" > 
                    Get Charter flights at the blink of an eye with Bookmyjet App.
                  </Typography>
                </Grid>
                <Grid item xs={12} sx={{color:"#fff"}}>
                <Typography variant="h6" component="h3" > 
                    Join the waitlist and get early bird access and benefits
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} display={{ xs: "block", md: "none" }} marginTop={{xs:"0em"}} sx={{ padding: "1em", marginBottom: "2em", textAlign: "center" }}>
              <Grid container>
                <Grid item xs={12} display="flex" justifyContent="center" alignItems="center" sx={{ color: "#fff" }}>
                  <Typography variant="h5" component="h3" >Discover the future of flying private</Typography>
                 
                </Grid>
                <Grid item xs={12} display="flex" justifyContent="center" alignItems="center" sx={{ color: "#fff" }}>
                  <Typography variant="subtitle2" component="h4">Redefining luxury and corporate private jet charter with exceptional service and professionalism.</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={0} md={2}></Grid>
            <Grid item xs={0} md={8} sx={{ marginBottom: "1em" }}>
              <HeroSection />
            </Grid>
            <Grid item xs={0} md={2}></Grid>

          </Grid>
        </Grid>
        </Grid>
      <Grid item xs={12} sx={{ backgroundColor: "#333333" }}>
        <Typography
          display={{xs:"block", md:"none"}}
          variant="subtitle1"
          component="h6" textAlign="center" color="#fff" py="5px"
        >
          Call now: +91-9711765512
        </Typography>
        <Typography variant='body1' component="p" textAlign="center" color="#fff" py="10px">
          © Copyright {new Date().getFullYear()} Bookmyjet All Rights Reserved
        </Typography>
      </Grid>
      <ToastContainer
      position="bottom-right"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />


    </React.Fragment>
  );
}
